"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9824],{

/***/ 49872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var listeners = [];
var state = {
  formErrorResponse: undefined,
  isInvalidForm: false,
  givenName: undefined
};

var setState = function setState(newState) {
  state = _objectSpread(_objectSpread({}, state), newState);
  listeners.forEach(function (listener) {
    listener(state);
  });
};

var useJanrainGlobalState = function useJanrainGlobalState() {
  var newListener = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)()[1];
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    listeners.push(newListener);
    return function cleanup() {
      if (listeners.indexOf(newListener) >= 0) {
        listeners.splice(listeners.indexOf(newListener), 1);
      }
    };
  }, []);
  return [state, setState];
};

/* harmony default export */ __webpack_exports__["Z"] = (useJanrainGlobalState);

/***/ }),

/***/ 90318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ deleteJanrainCaptureProfileDataFromLocalStorage; },
/* harmony export */   "Fi": function() { return /* binding */ getJanrainCaptureTokenFromLocalStorage; },
/* harmony export */   "NN": function() { return /* binding */ validateCustomSessionTimeoutActive; },
/* harmony export */   "QB": function() { return /* binding */ deleteIsCreatingAccountFromLocalStorage; },
/* harmony export */   "QR": function() { return /* binding */ removeSessionTimeoutFromLocalStorage; },
/* harmony export */   "Sm": function() { return /* binding */ setSessionTimeoutFromLocalStorage; },
/* harmony export */   "WZ": function() { return /* binding */ triggerLoginEvent; },
/* harmony export */   "_J": function() { return /* binding */ setProfileData; },
/* harmony export */   "cO": function() { return /* binding */ triggerRegisiterEvent; },
/* harmony export */   "mF": function() { return /* binding */ getJanrainCaptureTokenExpiresFromLocalStorage; },
/* harmony export */   "n_": function() { return /* binding */ getJanrainCaptureProfileDataFromLocalStorage; },
/* harmony export */   "s8": function() { return /* binding */ triggerLogoutEvent; },
/* harmony export */   "sv": function() { return /* binding */ setIsCreatingAccountToLocalStorage; },
/* harmony export */   "xO": function() { return /* binding */ getIsCreatingAccountFromLocalStorage; }
/* harmony export */ });
/* unused harmony exports getOralbProductListFromLocalStorage, setOralbProductListToLocalStorage, getOralbBenefitPreferenceListFromLocalStorage, setOralbBenefitPreferenceListToLocalStorage */
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73210);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24036);
/* harmony import */ var _redirect_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39693);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8996);
/* provided dependency */ var process = __webpack_require__(34155);






/*
* A common place to set, get and delete local storage items used in the login/register/profile process
* This reduces the risk of misspelling strings and making other mistakes
*/



var setProfileData = function setProfileData() {
  var userData = localStorage.getItem('janrainCaptureProfileData');

  if (userData) {
    var profileData = (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_6__/* .customSuperJsonParse */ .Cp)(userData); // Hardcoding value of marketingProgramNbr for Italy 

    var profileObject = {
      id: profileData.consumerID || profileData.uuid,
      marketingProgramNbr: process.env.MARKET && process.env.MARKET.trim() == 'it-it' ? "389" : profileData.marketingProgramNbr,
      sourceID: "14126",
      type: 'member'
    };

    if (window.PGdataLayer && !window.PGdataLayer.user) {
      window.PGdataLayer.user = {};
    }

    if (typeof Object.assign != 'function') {
      Object.assign = function (target) {
        'use strict';

        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];

          if (source != null) {
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
        }

        return target;
      };
    } else {
      Object.assign(window.PGdataLayer.user, profileObject);
    }
  } else {
    var _profileObject = {
      marketingProgramNbr: "389" || 0,
      sourceID: "14126",
      type: 'anonymous'
    };

    if (window.PGdataLayer && !window.PGdataLayer.user) {
      window.PGdataLayer.user = {};
    }

    if (typeof Object.assign != 'function') {
      Object.assign = function (target) {
        'use strict';

        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];

          if (source != null) {
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
        }

        return target;
      };
    } else {
      Object.assign(window.PGdataLayer.user, _profileObject);
    }
  }
};

var triggerEvent = function triggerEvent(eventCategory, eventAction) {
  var eventLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var callback = arguments.length > 3 ? arguments[3] : undefined;
  window.dataLayer.push({
    event: 'customEvent',
    GAeventCategory: eventCategory,
    GAeventAction: eventAction,
    GAeventLabel: eventLabel,
    GAeventValue: 0,
    GAeventNonInteraction: false,
    eventCallback: callback
  });
};

var triggerLoginEvent = function triggerLoginEvent() {
  // eslint-disable-next-line no-console
  try {
    triggerEvent('event_crm_action', 'event_profile_login_complete', 'oralb_successful_login');
  } catch (error) {
    console.error('GA is not loaded...');
  }
};
var triggerRegisiterEvent = function triggerRegisiterEvent() {
  // eslint-disable-next-line no-console
  try {
    /** Promise to make sure Login is called only after registration
     *  dont use EventCallout
     */
    new Promise(function (resolve) {
      return triggerEvent('event_crm_action', 'event_profile_register_complete', 'oralb_successful_register', resolve());
    }).then(function () {
      triggerEvent('event_crm_action', 'event_profile_login_complete', 'oralb_successful_login');
    });
  } catch (error) {
    console.error('GA is not loaded...');
  }
};
var triggerLogoutEvent = function triggerLogoutEvent() {
  if (!(window.PGdataLayer && window.PGdataLayer.user)) return;
  if (!window.PGdataLayer.user.id) return; // eslint-disable-next-line no-console

  try {
    triggerEvent('event_crm_action', 'event_profile_logout', 'oralb_successful_logout');
  } catch (error) {
    console.error('GA is not loaded...');
  }
};
var getOralbProductListFromLocalStorage = function getOralbProductListFromLocalStorage(uuid) {
  var key = JanrainConstants.productListLocalStorageKeyPrefix + uuid;
  return localStorage.getItem(key) || '[]';
};
var setOralbProductListToLocalStorage = function setOralbProductListToLocalStorage(productList, uuid) {
  var key = JanrainConstants.productListLocalStorageKeyPrefix + uuid;
  localStorage.setItem(key, productList);
};
var getOralbBenefitPreferenceListFromLocalStorage = function getOralbBenefitPreferenceListFromLocalStorage(uuid) {
  var key = JanrainConstants.benefitListLocalStorageKeyPrefix + uuid;
  return localStorage.getItem(key) || '[]';
};
var setOralbBenefitPreferenceListToLocalStorage = function setOralbBenefitPreferenceListToLocalStorage(benefitPreferenceList, uuid) {
  var key = JanrainConstants.benefitListLocalStorageKeyPrefix + uuid;
  localStorage.setItem(key, benefitPreferenceList);
};
var getIsCreatingAccountFromLocalStorage = function getIsCreatingAccountFromLocalStorage() {
  return localStorage.getItem('isCreatingAccount') || '';
};
var setIsCreatingAccountToLocalStorage = function setIsCreatingAccountToLocalStorage(value) {
  localStorage.setItem('isCreatingAccount', value);
};
var deleteIsCreatingAccountFromLocalStorage = function deleteIsCreatingAccountFromLocalStorage() {
  localStorage.removeItem('isCreatingAccount');
};
var getJanrainCaptureProfileDataFromLocalStorage = function getJanrainCaptureProfileDataFromLocalStorage() {
  return localStorage.getItem('janrainCaptureProfileData') || '{}';
};
var getJanrainCaptureTokenExpiresFromLocalStorage = function getJanrainCaptureTokenExpiresFromLocalStorage() {
  return localStorage.getItem('janrainCaptureToken_Expires') || '';
};
var getJanrainCaptureTokenFromLocalStorage = function getJanrainCaptureTokenFromLocalStorage() {
  return localStorage.getItem('janrainCaptureToken') || '';
};
var deleteJanrainCaptureProfileDataFromLocalStorage = function deleteJanrainCaptureProfileDataFromLocalStorage() {
  localStorage.removeItem('janrainCaptureToken');
  localStorage.removeItem('janrainFailedLogins');
  localStorage.removeItem('janrainCaptureReturnExperienceData');
  localStorage.removeItem('janrainCaptureProfileData');
  localStorage.removeItem('janrainCaptureToken_Expires');
  localStorage.removeItem('janrainCaptureReturnExperienceData_Expires');
  localStorage.removeItem('janrainCaptureProfileData_Expires');
  localStorage.removeItem('janrainSessionTimeoutDate');
};
var setSessionTimeoutFromLocalStorage = function setSessionTimeoutFromLocalStorage() {
  var timeoutDate = addMinutes(new Date(), parseInt(process.env.JANRAIN_SESSION_TIMOUT_MIN));
  localStorage.setItem('janrainSessionTimeoutDate', timeoutDate);
};
var removeSessionTimeoutFromLocalStorage = function removeSessionTimeoutFromLocalStorage() {
  localStorage.removeItem('janrainSessionTimeoutDate');
}; // session timeout layer added to invalidate janrain session if user is pass this timeout

var validateCustomSessionTimeoutActive = function validateCustomSessionTimeoutActive() {
  var sessionTimeout = localStorage.getItem('janrainSessionTimeoutDate');

  if (sessionTimeout) {
    var sessionTimeoutDate = new Date(sessionTimeout);

    if (!(sessionTimeoutDate > new Date())) {
      var _window, _window$janrain, _window$janrain$captu, _window$janrain$captu2;

      if ((_window = window) == null ? void 0 : (_window$janrain = _window.janrain) == null ? void 0 : (_window$janrain$captu = _window$janrain.capture) == null ? void 0 : (_window$janrain$captu2 = _window$janrain$captu.ui) == null ? void 0 : _window$janrain$captu2.endCaptureSession) {
        window.janrain.capture.ui.endCaptureSession();
        (0,_redirect_helpers__WEBPACK_IMPORTED_MODULE_7__/* .redirectTo */ .g)(process.env.JANRAIN_LOGIN_PATH);
      } else {
        deleteJanrainCaptureProfileDataFromLocalStorage();
        window.location.reload();
      }
    }
  }
};

function addMinutes(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

/***/ }),

/***/ 39693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ redirectTo; }
/* harmony export */ });
var redirectTo = function redirectTo(url) {
  window.history.replaceState(null, null, url);
  window.location.href = url;
};

/***/ }),

/***/ 39824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LoginNavigationBlock; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85696);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Janrain_Janrain_janrainForms_useJanrainGlobalState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49872);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8996);
/* harmony import */ var _Janrain_helpers_redirect_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39693);
/* harmony import */ var _Janrain_helpers_localstorage_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90318);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);
/* provided dependency */ var process = __webpack_require__(34155);










var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});
var ObLink = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(8958)]).then(__webpack_require__.bind(__webpack_require__, 61769));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61769)];
    }
  }
});




function LoginNavigationBlock(_ref) {
  var _document$fields, _document$fields$logi, _document$fields$logi2, _document$fields2, _document$fields2$log, _document$fields2$log2, _document$fields3, _document$fields3$reg, _document$fields3$reg2, _document$fields4, _document$fields4$reg, _document$fields4$reg2, _document$fields5, _document$fields5$log, _document$fields5$log2, _document$fields6, _document$fields6$wel, _document$fields6$wel2, _document$fields7, _document$fields7$wel, _document$fields7$wel2, _document$fields8, _document$fields9, _adchoices$fields, _adchoices$fields2, _adchoices$fields3, _externalRegisterLink, _externalRegisterLink2, _externalRegisterLink3;

  var document = _ref.document;
  var loginNavigationLabel = document == null ? void 0 : (_document$fields = document.fields) == null ? void 0 : (_document$fields$logi = _document$fields.loginNavigationLabel) == null ? void 0 : (_document$fields$logi2 = _document$fields$logi.fields) == null ? void 0 : _document$fields$logi2.text;
  var loginNavigationLink = document == null ? void 0 : (_document$fields2 = document.fields) == null ? void 0 : (_document$fields2$log = _document$fields2.loginNavigationLink) == null ? void 0 : (_document$fields2$log2 = _document$fields2$log.fields) == null ? void 0 : _document$fields2$log2.slug;
  var registerNavigationLabel = document == null ? void 0 : (_document$fields3 = document.fields) == null ? void 0 : (_document$fields3$reg = _document$fields3.registerNavigationLabel) == null ? void 0 : (_document$fields3$reg2 = _document$fields3$reg.fields) == null ? void 0 : _document$fields3$reg2.text;
  var registerNavigationLink = document == null ? void 0 : (_document$fields4 = document.fields) == null ? void 0 : (_document$fields4$reg = _document$fields4.registerNavigationLink) == null ? void 0 : (_document$fields4$reg2 = _document$fields4$reg.fields) == null ? void 0 : _document$fields4$reg2.slug;
  var logoutNavigationLabel = document == null ? void 0 : (_document$fields5 = document.fields) == null ? void 0 : (_document$fields5$log = _document$fields5.logoutNavigationLabel) == null ? void 0 : (_document$fields5$log2 = _document$fields5$log.fields) == null ? void 0 : _document$fields5$log2.text;
  var welcomeNavigationLabel = document == null ? void 0 : (_document$fields6 = document.fields) == null ? void 0 : (_document$fields6$wel = _document$fields6.welcomeNavigationLabel) == null ? void 0 : (_document$fields6$wel2 = _document$fields6$wel.fields) == null ? void 0 : _document$fields6$wel2.text;
  var welcomeNavigationLink = document == null ? void 0 : (_document$fields7 = document.fields) == null ? void 0 : (_document$fields7$wel = _document$fields7.welcomeNavigationLink) == null ? void 0 : (_document$fields7$wel2 = _document$fields7$wel.fields) == null ? void 0 : _document$fields7$wel2.slug;
  var adchoices = document == null ? void 0 : (_document$fields8 = document.fields) == null ? void 0 : _document$fields8.adchoices;
  var externalRegisterLink = document == null ? void 0 : (_document$fields9 = document.fields) == null ? void 0 : _document$fields9.externalRegisterLink;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      userData = _useState[0],
      setUserData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      firstName = _useState2[0],
      setFirstName = _useState2[1];

  var _useJanrainGlobalStat = (0,_Janrain_Janrain_janrainForms_useJanrainGlobalState__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(),
      _useJanrainGlobalStat2 = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0___default()(_useJanrainGlobalStat, 1),
      globalState = _useJanrainGlobalStat2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var profileData = JSON.parse((0,_Janrain_helpers_localstorage_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getJanrainCaptureProfileDataFromLocalStorage */ .n_)());
    var tokenExpiresData = (0,_Janrain_helpers_localstorage_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getJanrainCaptureTokenExpiresFromLocalStorage */ .mF)();
    var tokenExpiryDate = new Date();

    if (tokenExpiresData) {
      tokenExpiryDate = new Date(tokenExpiresData);
    }

    if (!(0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_6__/* .isObjectEmpty */ .nK)(profileData)) {
      var now = new Date();

      if (now < tokenExpiryDate) {
        setUserData(profileData);
        setFirstName(profileData == null ? void 0 : profileData.givenName);
      } else {
        // account expired, we delete all janrain data in localStorage,
        // this allow us to avoid initializing the widget in every page of the master site.
        (0,_Janrain_helpers_localstorage_helpers__WEBPACK_IMPORTED_MODULE_7__/* .deleteJanrainCaptureProfileDataFromLocalStorage */ .Ag)();
      }
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (globalState == null ? void 0 : globalState.givenName) {
      setFirstName(globalState == null ? void 0 : globalState.givenName);
    }
  }, [globalState]);

  var logout = function logout() {
    var _window, _window$janrain, _window$janrain$captu, _window$janrain$captu2;

    if ((_window = window) == null ? void 0 : (_window$janrain = _window.janrain) == null ? void 0 : (_window$janrain$captu = _window$janrain.capture) == null ? void 0 : (_window$janrain$captu2 = _window$janrain$captu.ui) == null ? void 0 : _window$janrain$captu2.endCaptureSession) {
      window.janrain.capture.ui.endCaptureSession();
      (0,_Janrain_helpers_redirect_helpers__WEBPACK_IMPORTED_MODULE_10__/* .redirectTo */ .g)(process.env.JANRAIN_LOGIN_PATH);
      (0,_Janrain_helpers_localstorage_helpers__WEBPACK_IMPORTED_MODULE_7__/* .triggerLogoutEvent */ .s8)();
    } else {
      (0,_Janrain_helpers_localstorage_helpers__WEBPACK_IMPORTED_MODULE_7__/* .deleteJanrainCaptureProfileDataFromLocalStorage */ .Ag)();
      window.location.reload();
      (0,_Janrain_helpers_localstorage_helpers__WEBPACK_IMPORTED_MODULE_7__/* .triggerLogoutEvent */ .s8)();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
    fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "ob-login-navigation",
      children: [adchoices && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
        fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(ObLink, {
          tag: 'a',
          href: (_adchoices$fields = adchoices.fields) == null ? void 0 : _adchoices$fields.url,
          className: "ob-login-navigation__adchoices",
          isExternalLink: true,
          isRelNofollow: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              children: adchoices == null ? void 0 : (_adchoices$fields2 = adchoices.fields) == null ? void 0 : _adchoices$fields2.title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
              fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Image, {
                image: adchoices == null ? void 0 : (_adchoices$fields3 = adchoices.fields) == null ? void 0 : _adchoices$fields3.image,
                noLazyLoad: true
              })
            })]
          })
        })
      }), loginNavigationLabel && loginNavigationLink && registerNavigationLabel && welcomeNavigationLink && welcomeNavigationLabel && logoutNavigationLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
        children: (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_6__/* .isObjectEmpty */ .nK)(userData) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(ObLink, {
            className: "ob-login-navigation__link ob-login-navigation__link-login event_profile_login",
            dataActionDetail: loginNavigationLabel,
            href: loginNavigationLink,
            children: loginNavigationLabel
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
            className: "ob-login-navigation__spacer",
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(ObLink, {
            className: "ob-login-navigation__link ob-login-navigation__link-register event_profile_register",
            dataActionDetail: registerNavigationLabel,
            href: registerNavigationLink,
            children: registerNavigationLabel
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(ObLink, {
            className: "ob-login-navigation__link ob-login-navigation__link-login",
            href: welcomeNavigationLink,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("span", {
              children: [welcomeNavigationLabel, " ", firstName]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
            className: "ob-login-navigation__spacer",
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("button", {
            "aria-label": logoutNavigationLabel,
            className: "ob-login-navigation__link ob-login-navigation__link-register",
            onClick: logout,
            children: logoutNavigationLabel
          })]
        })
      }), externalRegisterLink && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(ObLink, {
        className: "ob-login-navigation__link ob-login-navigation__link-register event_profile_register",
        dataActionDetail: externalRegisterLink == null ? void 0 : (_externalRegisterLink = externalRegisterLink.fields) == null ? void 0 : _externalRegisterLink.title,
        href: externalRegisterLink == null ? void 0 : (_externalRegisterLink2 = externalRegisterLink.fields) == null ? void 0 : _externalRegisterLink2.url,
        children: externalRegisterLink == null ? void 0 : (_externalRegisterLink3 = externalRegisterLink.fields) == null ? void 0 : _externalRegisterLink3.title
      })]
    })
  });
}

/***/ })

}]);